/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";

const ImageSelectorDisplay = (props) => {
    
    const { image, setOpen } = props;
    const url = image?.url;
    
    const openImageEditor = () => {
        setOpen(true);
    };
    
    return (
        <>
            <div
                className={"component-editor-image cover center"}
                style={{ backgroundImage: `url("${url}")`, width: "100%" }}
            >
                <div className='image-hover' onClick={openImageEditor}>
                    <div className='inner inner-image'>
                        <FontAwesomeIcon icon={faPlus}/> Edit
                    </div>
                </div>
            </div>
        </>
    );
};

export { ImageSelectorDisplay }; 